import { Stepper } from '@cgn/framework-ui-components/v1';
import { useState } from 'react';
import { existsSetInformazioniAggiuntive } from './categoria';

function getStepIndex(steps, step) {
  return steps.indexOf(step);
}

function getStatoStep(steps, step, currentStep) {
  if (getStepIndex(steps, step) < getStepIndex(steps, currentStep)) {
    return Stepper.State.DONE;
  }
  if (getStepIndex(steps, step) === getStepIndex(steps, currentStep)) {
    return Stepper.State.ACTIVE;
  }
  return Stepper.State.TODO;
}

export const stepSceltaServizio = 'SCELTA_SERVIZIO';
export const stepInformazioniAggiuntive = 'INFORMAZIONI_AGGIUNTIVE';
export const stepCompilaQuesito = 'COMPILO_QUESITO';

const stepsConInformazioniAggiuntive = [stepSceltaServizio, stepInformazioniAggiuntive, stepCompilaQuesito];
const stepsStandard = [stepSceltaServizio, stepCompilaQuesito];

export default function useNuovoQuestitoSteps(categoria) {
  const [currentStep, setCurrentStep] = useState(stepSceltaServizio);
  const steps = existsSetInformazioniAggiuntive(categoria) ? stepsConInformazioniAggiuntive : stepsStandard;

  return [
    currentStep,
    setCurrentStep,
    steps,
    [
      getStatoStep(steps, stepSceltaServizio, currentStep),
      getStatoStep(steps, stepInformazioniAggiuntive, currentStep),
      getStatoStep(steps, stepCompilaQuesito, currentStep),
    ],
  ];
}
